import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { styled, Stack, withUtility } from '@hub-la/design-system';
import { ImaginaryImageProcessor, AssetType, AssetStatus } from '@hub-la/fe-asset';
import { minWidth, width, height, css, alpha } from '@mui/system';
import EventDate from './event-date.js';
import { Fallback } from './fallback.js';
import Lock from './locked.js';
import { Pdf } from './pdf.js';
import { ProgressBar } from './progress-bar.js';

let _ = t => t,
  _t,
  _t2,
  _t3;
const Image = styled(ImaginaryImageProcessor)(_t || (_t = _`
  ${0};
  ${0};
  ${0};
  object-fit: cover;
`), minWidth, width, height);
const Container = styled(Stack)(_t2 || (_t2 = _`
  border-radius: 4px;
  overflow: hidden;

  ${0}
`), withUtility(({
  palette
}) => css(_t3 || (_t3 = _`
      position: relative;
      border: 1px solid ${0};
    `), alpha(palette('surface'), 0.2))));
const Thumbnail = ({
  width,
  height,
  onClick,
  hasProgressBar: _hasProgressBar = true,
  progress,
  eventStartTime,
  lockIcon,
  lockContent,
  asset,
  maxProgress,
  viewed,
  resizeHeight,
  resizeWidth
}) => {
  var _a, _b;
  const thumbnailImageUrl = (_a = asset === null || asset === void 0 ? void 0 : asset.metadata) === null || _a === void 0 ? void 0 : _a.thumbnailUrl;
  const isPdf = AssetType.application === (asset === null || asset === void 0 ? void 0 : asset.type);
  const isVideo = AssetType.video === (asset === null || asset === void 0 ? void 0 : asset.type);
  const isProcessing = [AssetStatus.processing, AssetStatus.uploading].includes(asset === null || asset === void 0 ? void 0 : asset.status);
  const pdf = asset === null || asset === void 0 ? void 0 : asset.url;
  const locked = lockIcon || lockContent;
  if (isVideo && isProcessing) {
    return jsx(Container, Object.assign({
      position: "relative",
      minWidth: width,
      width: width,
      height: height,
      onClick: onClick
    }, {
      children: jsx(Fallback, {
        isVideo: true
      })
    }));
  }
  if (isPdf) {
    return pdf || thumbnailImageUrl ? jsxs(Container, Object.assign({
      "data-testid": "thumbnail-pdf",
      minWidth: width,
      width: width,
      height: height,
      onClick: onClick
    }, {
      children: [locked && jsx(Lock, {
        fullSize: lockContent
      }), thumbnailImageUrl ? jsx(Image, {
        sourceUrl: thumbnailImageUrl,
        height: height,
        minWidth: width,
        width: width,
        ownerId: asset === null || asset === void 0 ? void 0 : asset.ownerId,
        sourceName: asset === null || asset === void 0 ? void 0 : asset.name,
        processParameter: {
          outputType: 'webp',
          width: resizeWidth !== null && resizeWidth !== void 0 ? resizeWidth : width,
          quality: 90
        }
      }) : jsx(Pdf, {
        url: asset === null || asset === void 0 ? void 0 : asset.url,
        width: width,
        height: height
      }), _hasProgressBar && !locked && jsx(ProgressBar, {
        viewed: viewed,
        progress: progress,
        maxProgress: maxProgress
      })]
    })) : jsxs(Container, Object.assign({
      position: "relative",
      minWidth: width,
      width: width,
      height: height,
      onClick: onClick
    }, {
      children: [locked && jsx(Lock, {
        fullSize: lockContent
      }), jsx(Fallback, {})]
    }));
  }
  return (thumbnailImageUrl !== null && thumbnailImageUrl !== void 0 ? thumbnailImageUrl : asset === null || asset === void 0 ? void 0 : asset.url) ? jsxs(Container, Object.assign({
    position: "relative",
    minWidth: width,
    width: width,
    height: height,
    onClick: onClick
  }, {
    children: [locked && jsx(Lock, {
      fullSize: lockContent
    }), eventStartTime && !locked && jsx(EventDate, {
      date: eventStartTime
    }), jsx(Image, {
      height: height,
      width: width,
      minWidth: width,
      "data-testid": "thumbnail-image",
      sourceUrl: (_b = thumbnailImageUrl !== null && thumbnailImageUrl !== void 0 ? thumbnailImageUrl : asset === null || asset === void 0 ? void 0 : asset.url) !== null && _b !== void 0 ? _b : '',
      ownerId: asset === null || asset === void 0 ? void 0 : asset.ownerId,
      sourceName: asset === null || asset === void 0 ? void 0 : asset.name,
      processParameter: {
        outputType: 'webp',
        width: resizeWidth !== null && resizeWidth !== void 0 ? resizeWidth : width,
        quality: 90
      }
    }), _hasProgressBar && !locked && jsx(ProgressBar, {
      viewed: viewed,
      progress: progress,
      maxProgress: maxProgress
    })]
  })) : jsxs(Container, Object.assign({
    position: "relative",
    minWidth: width,
    width: width,
    height: height,
    onClick: onClick
  }, {
    children: [locked && jsx(Lock, {
      fullSize: lockContent
    }), _hasProgressBar && !locked && jsx(ProgressBar, {
      viewed: viewed,
      progress: progress,
      maxProgress: maxProgress
    }), jsx(Fallback, {})]
  }));
};

export { Thumbnail };
